import { graphql } from "@/gql";

export const OVERVIEW_QUERY = graphql(`
  query OVERVIEW_QUERY {
    adminApplicationStatistics {
      id
      planCount
      organizationCount
      backgroundTaskCount
      userCount
      memberCount
      guardmeCount
      checkInCount
      rapidsosWorkflowCount
    }
    system {
      apiService
      assets
      databaseService
      incidentTypes
      infrastructure
      lambdaService
      jobQueueService
    }
    organizations {
      nodes {
        id
        name
        logoUrl
        memberCount
        createdAt
      }
    }
  }
`);
